import React, { ReactNode } from 'react';

const text: ReactNode = (
  <>
    <p data-testid="consent-text-paragraphs">
      Autorizo a ASSA Compañía de Seguros S.A. a realizar el rebajo de los
      montos pendientes, así como los ajustes correspondientes a la misma, por
      medio del sistema de cargo automático a la tarjeta.
    </p>

    <p>
      Esta autorización sólo podrá ser cancelada por mí, mediante una
      notificación escrita a ASSA Compañía de Seguros, S.A.
    </p>

    <p>
      En caso de renovación bajo los mismos términos y condiciones, se autoriza
      a ASSA Compañía de Seguros, S.A. a continuar realizando los cargos a esta
      misma tarjeta, en caso de que el Tarjetahabiente exprese lo contrario,
      deberá notificarlo por escrito.
    </p>

    <p>
      El importe de las primas está sujeto a modificaciones, ya sea por el
      asegurado o por la compañía, serán igualmente presentados al Banco para su
      cobro.
    </p>
    <p>
      Cada vez que cambie, renueve o reciba una nueva tarjeta, favor actualizar
      la información con el Departamento de Cobros.
    </p>
  </>
);

function ConsentText(): JSX.Element {
  return <>{text}</>;
}

export default ConsentText;
